<template>
    <div
        class="footer-container"
        @click="maybeOpenPrivacyCenter"
        @keydown.enter="maybeOpenPrivacyCenter"
    >
        <slot />
    </div>
</template>

<script>
import { promptConsent } from '../../services/trackingService.js';
import { deleteCookies } from '../../services/consentService.js';

export default {
    name: 'FooterComponent',
    methods: {
        maybeOpenPrivacyCenter({ target: { id } }) {
            if (id === 'consent-manager') {
                promptConsent();
            } else if (id === 'consent-delete') {
                deleteCookies();
            }
        }
    }
};
</script>

<style src="./footer.scss" lang="scss"></style>